import type { SrSalesOrderType } from '@plato/data/starrocks/types';
import { EllipsisVerticalIcon } from 'lucide-react';
import { Button } from '../../../components/ui/button.tsx';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu.tsx';
import { SearchEntity } from '../../../server/types/search-types.ts';
import { useCustomerBasis } from '../../customer-detail/hooks/use-customer-basis.ts';
import { DropdownMenuItemCreateTask } from '../../tasks/components/dropdown-menu-item-create-task.tsx';
import { DropdownMenuItemDelete, DropdownMenuItemRelease } from './quote-order-dropdown-menu-items.tsx';

type Props = {
    type: SrSalesOrderType;
    transactionId: string;
    customerId: string;
    onDelete?: () => void;
};

export function QuoteOrderActionDropdownMenu({ onDelete, transactionId, type, customerId }: Props) {
    const { data: customerBasis, isLoading } = useCustomerBasis({
        customerId,
    });

    return (
        <div className="relative">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant="icon"
                        icon={EllipsisVerticalIcon}
                        isLoading={isLoading}
                        disabled={isLoading}
                        isDisabled={isLoading}
                    />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="empty:hidden">
                    <DropdownMenuItemCreateTask
                        links={[
                            {
                                modelId: transactionId,
                                modelType:
                                    type === 'ORDER' ? SearchEntity.SalesOrder : SearchEntity.SalesQuote,
                                title: transactionId,
                            },
                            {
                                modelId: customerId,
                                modelType: SearchEntity.Customer,
                                title: customerBasis?.customerName || '',
                            },
                        ]}
                        source="quote_order_detail"
                    />
                    <DropdownMenuItemRelease transactionId={transactionId} type={type} />
                    <DropdownMenuItemDelete onDelete={onDelete} transactionId={transactionId} type={type} />
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
